// Voorgestelde namen. Een verkenning heet naar het gebied waarin je zoekt; een
// project dat eruit voortkomt naar waar zijn percelen liggen. Zo draagt een
// project niet de naam "Verkenning …" van zijn herkomst.

interface Located {
  place?: { city?: string; municipality?: string } | null;
}

const unique = (values: (string | undefined)[]) => [
  ...new Set(values.map((v) => v?.trim()).filter((v): v is string => !!v)),
];

const joinTwo = ([first, second]: string[]) => (second ? `${first} en ${second}` : first);

export const explorationName = (criteria: Record<string, any>, today: Date) => {
  const area = criteria.zone_2 || criteria.zone_1;
  return `Verkenning ${area || today.toLocaleDateString("nl-NL")}`;
};

// Eén of twee woonplaatsen bij naam; liggen de percelen verspreider, dan de
// gemeente (of twee). Lukt dat niet, dan de naam van de verkenning zonder het
// woord "Verkenning".
export const projectName = (parcels: Located[], explorationName: string) => {
  const cities = unique(parcels.map((p) => p.place?.city));
  if (cities.length && cities.length <= 2) return joinTwo(cities);
  const municipalities = unique(parcels.map((p) => p.place?.municipality));
  if (municipalities.length && municipalities.length <= 2) return joinTwo(municipalities);
  return explorationName.replace(/^Verkenning\s+/i, "").trim() || "Nieuw project";
};
